import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.palette.primary.contrastText};
  padding: 16px 20px;
  border: 1px solid ${(props) => props.theme.palette.darkTransparency};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  max-width: 335px;
  max-height: 185px;
  @media (max-width: 330px) {
    width: 300px;
  }

  header {
    padding: 0px 0px 16px;
    border-bottom: 1px solid ${(props) => props.theme.palette.darkTransparency};
  }
`;

export const Box = styled.div`
  font-size: 14px;
  color: ${(props) =>
    props.colorDark ? props.theme.palette.gray3 : props.theme.palette.gray1};

  span {
    color: ${(props) =>
      props.colorDark ? props.theme.palette.gray3 : props.theme.palette.gray1};
    font-size: ${(props) => (props.fontSizeLarger ? '16px' : '14px')};
    font-weight: ${(props) => (props.fontWeightLarger ? '600' : '500')};
    margin: 0px 2px;
  }
`;

export const Body = styled.div`
  padding: 16px 0px 0px;
  display: flex;
  img {
    margin: 0px 10px 0px 0px;
  }
`;
